/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ad_Commercial_Ad_HelpInputs */

const en_ad_commercial_ad_help = /** @type {(inputs: Ad_Commercial_Ad_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`For advertising content: on-screen text (disclaimers, supers, legal copy) is detected automatically and placed in separate AD events.`)
};

const fr_ad_commercial_ad_help = /** @type {(inputs: Ad_Commercial_Ad_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Indique à l'IA qu'il s'agit d'un contenu publicitaire et l'invite à gérer les mentions légales à l'écran.`)
};

const de_ad_commercial_ad_help = /** @type {(inputs: Ad_Commercial_Ad_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Teilt der KI mit, dass es sich um Werbeinhalte handelt, und fordert sie auf, die auf dem Bildschirm angezeigten Warnhinweise zu verarbeiten.`)
};

const it_ad_commercial_ad_help = /** @type {(inputs: Ad_Commercial_Ad_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Comunica all'IA che si tratta di contenuti pubblicitari e la invita a gestire le note legali visualizzate sullo schermo.`)
};

const ru_ad_commercial_ad_help = /** @type {(inputs: Ad_Commercial_Ad_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Сообщает ИИ, что это рекламный контент, и дает команду обработать экранные предупреждения.`)
};

const es_ad_commercial_ad_help = /** @type {(inputs: Ad_Commercial_Ad_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Le indica a la IA que se trata de contenido publicitario y le solicita que gestione los avisos legales que aparecen en pantalla.`)
};

const zh_cn2_ad_commercial_ad_help = /** @type {(inputs: Ad_Commercial_Ad_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`告诉人工智能这是广告内容，并提示它处理屏幕上的免责声明。`)
};

const ja_ad_commercial_ad_help = /** @type {(inputs: Ad_Commercial_Ad_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`これは広告コンテンツであることをAIに伝え、画面上の免責事項を処理するように促します。`)
};

const hi_ad_commercial_ad_help = /** @type {(inputs: Ad_Commercial_Ad_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`यह एआई को बताता है कि यह विज्ञापन सामग्री है और उसे ऑन-स्क्रीन अस्वीकरणों को संभालने के लिए प्रेरित करता है।`)
};

const pt_pt2_ad_commercial_ad_help = /** @type {(inputs: Ad_Commercial_Ad_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Informa à IA que se trata de conteúdo publicitário e a instrui a lidar com os avisos legais na tela.`)
};

/**
* | output |
* | --- |
* | "For advertising content: on-screen text (disclaimers, supers, legal copy) is detected automatically and placed in separate AD events." |
*
* @param {Ad_Commercial_Ad_HelpInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const ad_commercial_ad_help = /** @type {((inputs?: Ad_Commercial_Ad_HelpInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ad_Commercial_Ad_HelpInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_ad_commercial_ad_help(inputs)
	if (locale === "de") return de_ad_commercial_ad_help(inputs)
	if (locale === "it") return it_ad_commercial_ad_help(inputs)
	if (locale === "ru") return ru_ad_commercial_ad_help(inputs)
	if (locale === "es") return es_ad_commercial_ad_help(inputs)
	if (locale === "zh-CN") return zh_cn2_ad_commercial_ad_help(inputs)
	if (locale === "ja") return ja_ad_commercial_ad_help(inputs)
	if (locale === "hi") return hi_ad_commercial_ad_help(inputs)
	if (locale === "pt-PT") return pt_pt2_ad_commercial_ad_help(inputs)
	return en_ad_commercial_ad_help(inputs)
});